import React, { useMemo } from 'react';
import { Table, Radio, Space, Col } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

export const ComparisonTable = ({ dataSource = [], onChange, value }) => {
  const handleChange = (key) => () => {
    onChange(key);
  };

  const TableCell = ({ value: cellValue }) => {
    if (typeof cellValue === 'string') {
      return cellValue;
    }
    if (typeof cellValue === 'boolean') {
      return cellValue ? <CheckCircleOutlined /> : <CloseCircleOutlined />;
    }

    return <CloseCircleOutlined />;
  };

  const columns = useMemo(() => {
    const sourceColumns = dataSource.map((item) => {
      const { title, key, selectable = true } = item;
      return {
        title: selectable ? (
          <Radio
            checked={value === key}
            onChange={handleChange(key)}
            className="comparison-table__radio"
          >
            <style>
              {`.comparison-table__radio .ant-radio{
                top: 0.2em !important;
              }`}
            </style>
            {title}
          </Radio>
        ) : (
          title
        ),
        dataIndex: key,
        key,
        render: (v) => <TableCell value={v} />
      };
    });

    sourceColumns.unshift({
      title: ' ',
      dataIndex: 'name',
      key: 'name',
      isInfoColumn: true
    });

    return sourceColumns;
  }, [dataSource, value]);

  const rows = useMemo(() => {
    const dataMap = new Map();
    dataSource.forEach((item) => {
      const { data, key: columnKey } = item;

      Object.keys(data).forEach((key) => {
        const row = dataMap.get(key) || {};
        row.name = data[key]?.label || key;
        row[columnKey] = data[key]?.value;
        dataMap.set(key, row);
      });
    });

    const datas = Array.from(dataMap.values());
    datas.push({
      name: ' ',
      ...dataSource.reduce((acc, item) => {
        acc[item.key] = item.title;
        return acc;
      }, {})
    });

    return datas;
  }, [dataSource]);

  return (
    <>
      <Table
        columns={columns}
        dataSource={rows}
        pagination={false}
        rowKey="name"
        className="comparison-table"
      />
    </>
  );
};
